module.exports = {
  postPublish: "Published on ",
  postRelatedPosts: "You might also be *interested in these posts.*",

  "404Title": "Page not found",
  "404Subtitle": "Please check the URL in the address bar and try again.",
  "404Button": "Go back home",

  nlEmailField: "Email address",
  nlSubmit: "Submit ",
}
